import { render, staticRenderFns } from "./todolist.vue?vue&type=template&id=3008256e&scoped=true"
import script from "./todolist.vue?vue&type=script&lang=js"
export * from "./todolist.vue?vue&type=script&lang=js"
import style0 from "./todolist.vue?vue&type=style&index=0&id=3008256e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3008256e",
  null
  
)

export default component.exports